import clsx from "clsx";
import copy from "copy-to-clipboard";
import { useToasts } from "react-toast-notifications";

import { GenericTooltip } from "@components/tooltip-container";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { useProductAnalyticsContext } from "@features/product-analytics/hooks";
import { useDesignElementManager } from "@hooks/use-design-element-manager";
import { generateAnonBase64Hash } from "@utils/anonymous";
import { usePrefs } from "@utils/client-side-preferences";

import { platformIdsForQuery } from "../../../metricsData";

export const NameDataFormatter = ({
  row,
  column,
}: DataTypeProvider.ValueFormatterProps) => {
  const { addToast } = useToasts();

  const prefs = usePrefs();
  const isAnon = prefs.isDemoMode;
  const { designElementManager } = useDesignElementManager();
  const {
    tabState,
    setProductItemRelationModalOpen,
    setSelectedRelationRow,
    productItemRelationModalOpen,
  } = useProductAnalyticsContext();
  return (
    <div
      className={clsx(
        "flex items-center mx-3 h-full font-sans relative name-table-cell",
      )}
    >
      <div className="hide-cell-actions absolute h-full right-0">
        <div className="h-full flex items-center space-x-2">
          <GenericTooltip
            content="Copy"
            noInfoCircle
            overlayClassName="pointer-events-none bg-black text-white"
          >
            <i
              className={clsx(
                "bg-v2-primary elevation-1 rounded-full p-[5px] fa-sharp fa-solid fa-clone",
                "cursor-pointer text-md text-primary font-light",
              )}
              onClick={() => {
                addToast("COPIED NAME TO CLIPBOARD", { appearance: "success" });
                copy(row.name);
              }}
            ></i>
          </GenericTooltip>
          {/* {tabState.tabView === "product" && (
            <GenericTooltip
              content="Remove from view. Removed items can be found under filters"
              noInfoCircle
              overlayClassName="pointer-events-none bg-black text-white max-w-[200px]"
            >
              <button>
                <i
                  className={clsx(
                    "bg-v2-primary elevation-1 rounded-full p-[5px] fa-sharp fa-solid fa-eye-slash",
                    "cursor-pointer text-md text-[#F05F33] font-light",
                  )}
                  onClick={() => {
                    console.log("SHOW CONFIRM MODAL WITH ARE YOU SURE", row.id);
                  }}
                ></i>
              </button>
            </GenericTooltip>
          )} */}
        </div>
      </div>
      <div
        onClick={() => {
          if (column.title === "Product Name") {
            return;
          }
          setSelectedRelationRow(row);
          setProductItemRelationModalOpen(true);
        }}
        className={clsx(
          "flex items-start flex-column w-full truncate",
          column.title !== "Product Name" && "text-[#7081FF] cursor-pointer",
        )}
      >
        <span
          className={clsx(
            "font-semibold text-sm text-left w-full truncate flex gap-1 items-center",
          )}
        >
          {tabState.tabView === "platform" &&
            column.title !== "Product Name" &&
            designElementManager
              .getDesignElement(row.name)
              .getComponent({ size: "26" })}
          {generateAnonBase64Hash({
            value: row.name,
            prefix: productItemRelationModalOpen ? "product" : tabState.tabView,
            doAnon: isAnon,
          })}
        </span>
      </div>
    </div>
  );
};
